"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _initial2 = _interopRequireDefault(require("lodash/initial"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _MenuItem = _interopRequireDefault(require("../Navigation/MenuItem"));

var _ChevronDownIcon = _interopRequireDefault(require("../Icons/ChevronDownIcon"));

var _ChevronRightIcon = _interopRequireDefault(require("../Icons/ChevronRightIcon"));

var _Title = _interopRequireDefault(require("../Typography/Title"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['type', 'expanded'];
/**
 * This is for use with Menu component.
 */

var MenuGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuGroup, _React$Component);

  function MenuGroup(props) {
    var _this;

    _classCallCheck(this, MenuGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuGroup).call(this, props));
    _this.handleMenuChange = _this.handleMenuChange.bind(_assertThisInitialized(_this));
    _this.state = {
      currentHeight: 0
    };
    return _this;
  }

  _createClass(MenuGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMGHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMGHeight();
    }
    /*
     * Updates collapsible menu group height based on height of children nodes
     */

  }, {
    key: "updateMGHeight",
    value: function updateMGHeight() {
      var type = this.props.type; // Combine header height and collapsible group height. We are doing
      // some magic to allow us to continue calcualating collapse group height
      // even when it is not visible.

      if (type === 'collapsible') {
        var mhHeight = (0, _ReactElementUtils.measureElement)(this.mhRef).height;
        var cgHeight = (0, _ReactElementUtils.measureElement)(this.cgRef).height;
        var elHeight = mhHeight + cgHeight;

        if (this.state.currentHeight !== elHeight) {
          this.setState({
            currentHeight: elHeight
          });
        }
      }
    }
    /**
     * Handler for menu change
     * @param {object} info - menu info
     * See props onClick for further details.
     */

  }, {
    key: "handleMenuChange",
    value: function handleMenuChange(info) {
      var event = info.event,
          key = info.key,
          keyPath = info.keyPath,
          openKeyMap = info.openKeyMap,
          item = info.item,
          type = info.type;
      var _this$props = this.props,
          assignedKey = _this$props.assignedKey,
          onClick = _this$props.onClick; // since user does not know about internal ids... we drop it

      var newKeyPath;

      if (info.type === 'collapsible-header' && this.isLastKeyInternal(keyPath)) {
        newKeyPath = [assignedKey].concat(_toConsumableArray((0, _initial2.default)(keyPath)));
      } else {
        newKeyPath = [assignedKey].concat(_toConsumableArray(keyPath));
      }

      var newInfo = {
        event: event,
        key: key,
        keyPath: newKeyPath,
        openKeyMap: openKeyMap,
        item: item,
        type: type
      };

      if ((0, _isFunction2.default)(onClick)) {
        onClick(newInfo);
      }
    }
    /**
     * Check if last key was internally added
     * @param {array} keyPath - path of keys
     * @returns {node} MenuItem with header attributes
     */

  }, {
    key: "isLastKeyInternal",
    value: function isLastKeyInternal(keyPath) {
      return keyPath[keyPath.length - 1].indexOf('_internal') !== -1;
    }
    /**
     * Check if last key was internally added
     * @param {string} title - Title for menu group
     * @param {string} type - Type of menu group
     * @param {boolean} expanded - Whether or not group is expanded
     * @returns {boolean} true if last key is internally managed
     */

  }, {
    key: "renderHeader",
    value: function renderHeader(title, type, expanded) {
      var _this2 = this;

      var header;

      if (title) {
        switch (type) {
          case 'collapsible':
            header = _react.default.createElement(_MenuItem.default, {
              ref: function ref(node) {
                _this2.mhRef = node;
              },
              onClick: this.handleMenuChange,
              justifyContent: "space-between",
              type: "collapsible-header",
              assignedKey: "".concat(this.props.assignedKey, "_internal")
            }, _react.default.createElement("span", null, title), _react.default.createElement(_ChevronDownIcon.default, null));
            break;

          case 'submenu':
            header = _react.default.createElement(_MenuItem.default, {
              onClick: this.handleMenuChange,
              className: "mg-submenu",
              justifyContent: "space-between",
              type: "collapsible-header",
              assignedKey: "".concat(this.props.assignedKey, "_internal")
            }, _react.default.createElement("span", null, title), _react.default.createElement(_ChevronRightIcon.default, null));
            break;

          default:
            header = _react.default.createElement(_StackingLayout.default, {
              className: "mg-title",
              padding: "0px-20px"
            }, _react.default.createElement(_Title.default, {
              size: "h4"
            }, title));
        }
      }

      return header;
    }
  }, {
    key: "renderContent",
    value: function renderContent(type, children) {
      var _this3 = this;

      var content;

      switch (type) {
        case 'collapsible':
          content = _react.default.createElement("div", {
            className: "collapsible-group",
            ref: function ref(node) {
              _this3.cgRef = node;
            }
          }, children);
          break;

        case 'submenu':
          content = _react.default.createElement("div", {
            className: "submenu"
          }, children);
          break;

        default:
          content = children;
      }

      return content;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      /* eslint-disable no-unused-vars */
      var _this$props2 = this.props,
          assignedKey = _this$props2.assignedKey,
          className = _this$props2.className,
          onClick = _this$props2.onClick,
          assignMenuManagement = _this$props2.assignMenuManagement,
          title = _this$props2.title,
          type = _this$props2.type,
          activeKeyPath = _this$props2.activeKeyPath,
          openKeyMap = _this$props2.openKeyMap,
          expanded = _this$props2.expanded,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, ["assignedKey", "className", "onClick", "assignMenuManagement", "title", "type", "activeKeyPath", "openKeyMap", "expanded", "children"]);
      /* eslint-enable */


      var childrenWithProps = assignMenuManagement ? assignMenuManagement({
        children: children,
        activeKeyPath: activeKeyPath,
        openKeyMap: openKeyMap,
        onClickCallback: this.handleMenuChange
      }) : null;
      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props); // Apply set height to run transition

      var inlineStyle;

      if (this.state.currentHeight && expanded) {
        inlineStyle = {
          height: this.state.currentHeight
        };
      }

      return _react.default.createElement(_StackingLayout.default, _extends({
        itemSpacing: "0px",
        ref: function ref(node) {
          _this4.mgRef = node;
        },
        style: inlineStyle,
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-menu-group"))
      }, styleProps, props), this.renderHeader(title, type, expanded), this.renderContent(type, childrenWithProps));
    }
  }]);

  return MenuGroup;
}(_react.default.Component);

exports.default = MenuGroup;
MenuGroup.defaultProps = {
  type: 'default'
};
MenuGroup.propTypes = {
  /**
   * Provide additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * (For internal use) Key path that is active.
   */
  activeKeyPath: _propTypes.default.array,

  /**
   * (For internal use) This key should be identical to key.
   */
  assignedKey: _propTypes.default.string,

  /**
   * (For internal use) Handler to assign additional props to child menu items.
   */
  assignMenuManagement: _propTypes.default.func,

  /**
   * The children can be MenuItem, MenuGroup, Divider, or any other
   * element preferred.
   */
  children: _propTypes.default.node,

  /**
   * (For internal use) Used for collapsible menus.
   */
  expanded: _propTypes.default.bool,

  /**
   * (For internal use) Used to open collapsible MenuGroups.
   *
   * A multidimensional array of paths of keys that are currently open. The
   * last key in the array is the selected menu group.
   */
  openKeyMap: _propTypes.default.arrayOf(_propTypes.default.array),

  /**
   * The onClick handler. Note: This is removed when used within a Menu component.
   */
  onClick: _propTypes.default.func,

  /**
   * Title for menu group. Can be string or node.
   */
  title: _propTypes.default.node,

  /**
   * Type of group.
   */
  type: _propTypes.default.oneOf(['default', 'collapsible', 'submenu'])
};